export default (state: any, action: any) => {
	switch (action.type) {
		case 'SET_FUNNEL':
			return { ...state, funnel: action.data };
		case 'RESET':
			return { ...state, funnel: action.data };

		default:
			return state;
	}
};
